import { useMutation, useQueryClient } from '@tanstack/vue-query'

import { createAdmin } from '../adminsEndpoints'
import { adminsQueryKeys } from '../adminsQueryKeys'
import type { UpsertAdminPayload } from '../../types/adminTypes'

export function useCreateAdminMutation() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (payload: UpsertAdminPayload) => createAdmin(payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: adminsQueryKeys.lists() })
    },
  })
}
